import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useEffect } from 'react';
import { SparkSuspense } from '../../../components/spark-suspense';
import { useSite, withPageProviders } from '../../../context/page-context';
import { track } from '../../../lib/mixpanel';
import { PlansGrid, PlansGridSkeleton } from '../components/plans-grid';
import { useAvailablePlans } from '../hooks/use-available-plans';
import { useBillingData } from '../hooks/use-billing-data';

function BillingChangePlanPageContent() {
  const site = useSite();
  const plansQuery = useAvailablePlans();
  const dataQuery = useBillingData();

  useEffect(() => {
    track(site, 'Billing Change Plan Page Viewed', {});
  }, [site]);

  const isLoading = plansQuery.isLoading || dataQuery.isLoading;
  const isError = plansQuery.isError || dataQuery.isError;

  return (
    <Page title={t('features:billing.pages.change_plan.title')}>
      {plansQuery.data && dataQuery.data ? (
        <PlansGrid availablePlans={plansQuery.data} activePlanKey={dataQuery.data.activePlanKey} />
      ) : isLoading ? (
        <PlansGridSkeleton />
      ) : (
        <SparkSuspense
          isLoading={false}
          isError={isError}
          errorMessage={t('features:billing.pages.errors.load_plans')}
          onReload={() => {
            void plansQuery.refetch();
            void dataQuery.refetch();
          }}
        />
      )}
    </Page>
  );
}

export const BillingChangePlanPage = withPageProviders(BillingChangePlanPageContent);
